var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "el-dialog",
    {
      directives: [{ name: "drag", rawName: "v-drag" }],
      attrs: {
        title: "数据审核",
        visible: _vm.dialogVisible,
        width: "1200px",
        "close-on-click-modal": false,
        "close-on-press-escape": false,
        "append-to-body": "",
        "before-close": _vm.cancel,
      },
      on: {
        "update:visible": function ($event) {
          _vm.dialogVisible = $event
        },
      },
    },
    [
      _c(
        "div",
        {
          directives: [
            {
              name: "loading",
              rawName: "v-loading",
              value: _vm.loading,
              expression: "loading",
            },
          ],
          staticClass: "content",
        },
        [
          _c("BaseTable", {
            ref: "tableData",
            attrs: {
              height: 440,
              tableData: {
                ..._vm.tableData,
                fileds: _vm.fileds,
              },
              selectRows: _vm.selections,
              isPager: false,
            },
            on: { handleSelectionChange: _vm.handleSelectionChange },
            scopedSlots: _vm._u([
              {
                key: "message",
                fn: function (row) {
                  return [
                    row.scope.message
                      ? _c(
                          "el-tooltip",
                          {
                            staticClass: "item",
                            attrs: {
                              effect: "dark",
                              content: row.scope.message,
                              placement: "top-start",
                            },
                          },
                          [
                            _c("i", {
                              staticClass: "el-icon-warning",
                              staticStyle: { color: "#fe453d" },
                            }),
                          ]
                        )
                      : _vm._e(),
                  ]
                },
              },
            ]),
          }),
          _c("p", { staticClass: "tips" }, [
            _vm._v(" 共选择 "),
            _c("span", { staticStyle: { color: "#fe453d" } }, [
              _vm._v(_vm._s(_vm.selections.length)),
            ]),
            _vm._v(" 条数据 "),
          ]),
        ],
        1
      ),
      _c(
        "span",
        { staticClass: "footers", attrs: { slot: "footer" }, slot: "footer" },
        [
          _c(
            "div",
            { staticClass: "cancel flex_c_c", on: { click: _vm.cancel } },
            [_vm._v("取 消")]
          ),
          _c("div", { staticClass: "ok flex_c_c", on: { click: _vm.ok } }, [
            _vm._v("确 定"),
          ]),
        ]
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }